/**
 * "Entered by us from a phone call with Jane Smith" — beside an answer we typed.
 *
 * The counterpart of ProvenanceNote. A customer's answer says nothing beside
 * it; one of ours always says so, so nothing we entered is ever read as theirs.
 */
import page from '../../../shared/Page.module.css';
import { formatDayUS } from '../../../shared/dates';
import { methodPhrase } from './entryMethods';
import type { StaffField } from './types';

export function staffWords(f: StaffField): string {
  const from = methodPhrase(f.method, f.detail);
  return `Entered by ${f.byEmail ?? 'StandingDocs'} from ${from}`
    + `${f.givenByName ? ` with ${f.givenByName}` : ''}, ${formatDayUS(f.at)}`;
}

export function StaffMark({ field }: { field: StaffField | undefined }) {
  if (!field) return null;
  return <div className={page.itemMeta}>{staffWords(field)}</div>;
}
